// ZZYON · Torre Binário — main.js
import './styles.css';
import { db, auth, repo, getCurrentUser, signInMagic, signOut, isAuthorizedEmail, isBinarioUser } from './client.js';
import { viewUpload } from './views/upload.js';
import { viewEtiquetas } from './views/etiquetas.js';
import { viewEnderecamento } from './views/enderecamento.js';
import { viewPicking } from './views/picking.js';
import { viewRemessas } from './views/remessas.js';
import { viewSyncEsl } from './views/sync-esl.js';
import { viewAutomacoes } from './views/automacoes.js';
import { viewInventario } from './views/inventario.js';
import { viewDivergencias } from './views/divergencias.js';
import { viewMobile } from './views/mobile.js';
import { viewReposicao } from './views/reposicao.js';

const $app = document.getElementById('app');

// ─── Helpers ────────────────────────────────────────────────────────────
const BRL = (v) => 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const BRLmi = (v) => 'R$ ' + (Number(v || 0) / 1_000_000).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' mi';
const NUM = (v) => Number(v || 0).toLocaleString('pt-BR');
const QTY = (v) => Number(v || 0).toLocaleString('pt-BR', { maximumFractionDigits: 3 });
const DATE = (s) => s ? new Date(s).toLocaleDateString('pt-BR') : '—';
const SHORT = (s, n) => s ? (s.length > n ? s.slice(0, n) + '…' : s) : '';

const escapeHTML = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

const LOGO_SVG = `
  <svg class="login-brand-logo" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    <rect width="200" height="200" rx="32" fill="#0A0E27"/>
    <circle cx="100" cy="100" r="78" fill="none" stroke="#3B6EFF" stroke-width="1.5" stroke-dasharray="3,3"/>
    <path d="M 60 60 L 140 60 L 64 100 L 140 100 L 64 140 L 140 140" fill="none" stroke="#FFFFFF" stroke-width="9" stroke-linecap="square"/>
    <circle cx="170" cy="56" r="7" fill="#3B6EFF"/>
  </svg>`;

const NAV = [
  { id: 'dashboard',     label: 'Dashboard',         icon: '◎', group: 'visao' },
  { id: 'estoque',       label: 'Estoque agora',     icon: '◫', group: 'visao' },
  { id: 'movimento',     label: 'Movimentação',      icon: '⇅', group: 'visao' },
  { id: 'fretes',        label: 'Fretes ESL',        icon: '↗', group: 'visao' },
  { id: 'abc',           label: 'ABC × XYZ',         icon: '▦', group: 'visao' },

  { id: 'upload',        label: 'Upload XML',        icon: '▽', group: 'operacao' },
  { id: 'etiquetas',     label: 'Etiquetas',         icon: '▦', group: 'operacao' },
  { id: 'enderecamento', label: 'Endereçamento',     icon: '◰', group: 'operacao' },
  { id: 'picking',       label: 'Picking',           icon: '⇉', group: 'operacao' },
  { id: 'remessas',      label: 'Remessas sem nota', icon: '⇄', group: 'operacao' },
  { id: 'inventario',    label: 'Inventário cíclico',icon: '⊟', group: 'operacao' },
  { id: 'divergencias',  label: 'Divergências',      icon: '⚠', group: 'operacao' },

  { id: 'mobile',        label: 'Mobile (scan QR)',  icon: '◍', group: 'operacao' },

  { id: 'reposicao',     label: 'Reposição',         icon: '↻', group: 'visao' },

  { id: 'sync-esl',      label: 'Sincronizar ESL',   icon: '⟳', group: 'sistema' },
  { id: 'automacoes',    label: 'Automações',        icon: '⟿', group: 'sistema' },
  { id: 'saude',         label: 'Saúde dos dados',   icon: '◊', group: 'sistema' },
];

const GROUPS = {
  visao:    'Visão executiva',
  operacao: 'Operação WMS',
  sistema:  'Sistema',
};

// ─── Router ─────────────────────────────────────────────────────────────
function currentRoute() {
  const hash = location.hash.replace(/^#\/?/, '');
  const parts = hash.split('/');
  const id = parts[0] || 'dashboard';
  return { id, path: parts.slice(1) };
}
function navigate(id) { location.hash = `#/${id}`; }

// ─── Auth flow ──────────────────────────────────────────────────────────
async function renderLogin(msg) {
  $app.innerHTML = `
    <div class="login">
      <div class="login-card">
        <div class="login-brand">
          ${LOGO_SVG}
          <div class="login-brand-text">
            <span class="login-brand-name">ZZYON</span>
            <span class="login-brand-sub">TORRE BINÁRIO</span>
          </div>
        </div>
        <h1>WMS espelho<br><strong>Binário Joinville</strong></h1>
        <p class="lead">Acesso restrito às equipes Ícaro Express (<span class="mono-inline">@icaroexpress.com</span>) e Binário (<span class="mono-inline">@binario.net</span>). Entre com seu e-mail corporativo para receber um link mágico de acesso.</p>
        <form id="login-form">
          <label for="email">E-MAIL CORPORATIVO</label>
          <input id="email" type="email" placeholder="voce@icaroexpress.com  ·  voce@binario.net" required autocomplete="email" />
          <button type="submit" id="login-btn">Receber link de acesso</button>
          ${msg ? `<div class="msg ${msg.kind}">${escapeHTML(msg.text)}</div>` : ''}
        </form>
        <div class="login-foot">
          ZZYON DO BRASIL <span class="dot">·</span> EDIÇÃO 1.0 <span class="dot">·</span> CONFIDENCIAL
        </div>
      </div>
    </div>`;
  document.getElementById('login-form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = document.getElementById('email').value.trim();
    const btn = document.getElementById('login-btn');
    btn.disabled = true; btn.textContent = 'Enviando…';
    try {
      await signInMagic(email);
      await renderLogin({ kind: 'ok', text: 'Link enviado. Verifique seu e-mail e clique para entrar.' });
    } catch (err) {
      await renderLogin({ kind: 'err', text: err.message || 'Falha ao enviar link.' });
    }
  });
}

// ─── App shell ──────────────────────────────────────────────────────────
async function renderApp(user) {
  const initial = user.email[0].toUpperCase();
  const userIsBinario = isBinarioUser(user.email);
  const role = userIsBinario ? 'BINÁRIO · CLIENTE' : 'OPERAÇÃO ÍCARO';
  $app.innerHTML = `
    <div class="app">
      <aside class="sidebar">
        <div class="sidebar-brand">
          ${LOGO_SVG.replace('class="login-brand-logo"', 'class="sidebar-brand-logo"')}
          <div class="sidebar-brand-text">
            <span class="sidebar-brand-name">ZZYON</span>
            <span class="sidebar-brand-sub">TORRE BINÁRIO</span>
          </div>
        </div>
        <div class="sidebar-cobrand">
          <span class="sidebar-cobrand-label">OPERAÇÃO 3PL</span>
          <div class="sidebar-cobrand-row">
            <span class="sidebar-cobrand-icaro">ÍCARO EXPRESS</span>
            <span class="sidebar-cobrand-x">×</span>
            <img src="/logo-binario.svg" alt="Binário" class="sidebar-cobrand-binario" />
          </div>
        </div>
        <nav id="nav-list">
          ${Object.entries(GROUPS).map(([gid, glabel]) => {
            const items = NAV.filter(n => n.group === gid);
            if (items.length === 0) return '';
            return `
              <div class="sidebar-section">
                <div class="sidebar-section-title">${glabel}</div>
                ${items.map(n => `
                  <div class="nav-item" data-route="${n.id}">
                    <span class="nav-icon">${n.icon}</span>
                    <span>${n.label}</span>
                  </div>`).join('')}
              </div>`;
          }).join('')}
        </nav>
        <div class="sidebar-user">
          <div class="sidebar-user-avatar" style="${userIsBinario ? 'background: var(--binario);' : ''}">${initial}</div>
          <div class="sidebar-user-info">
            <div class="sidebar-user-email" title="${escapeHTML(user.email)}">${escapeHTML(user.email)}</div>
            <div class="sidebar-user-role ${userIsBinario ? 'role-binario' : ''}">${role}</div>
          </div>
          <button class="signout" id="btn-signout">SAIR</button>
        </div>
      </aside>
      <main class="content" id="content"></main>
    </div>`;
  document.getElementById('btn-signout').addEventListener('click', signOut);
  document.getElementById('nav-list').addEventListener('click', (e) => {
    const item = e.target.closest('.nav-item');
    if (item) navigate(item.dataset.route);
  });
  window.addEventListener('hashchange', renderRoute);
  await renderRoute();
}

function setActive(routeId) {
  document.querySelectorAll('.nav-item').forEach(el => el.classList.toggle('active', el.dataset.route === routeId));
}

async function renderRoute() {
  const { id } = currentRoute();
  setActive(id);
  const $c = document.getElementById('content');
  $c.innerHTML = `<div class="empty"><span class="spinner"></span>Carregando…</div>`;
  try {
    switch (id) {
      case 'dashboard':     await viewDashboard($c);     break;
      case 'estoque':       await viewEstoque($c);       break;
      case 'movimento':     await viewMovimento($c);     break;
      case 'abc':           await viewAbcXyz($c);        break;
      case 'fretes':        await viewFretes($c);        break;
      case 'upload':        await viewUpload($c);        break;
      case 'etiquetas':     await viewEtiquetas($c);     break;
      case 'enderecamento': await viewEnderecamento($c); break;
      case 'picking':       await viewPicking($c);       break;
      case 'remessas':      await viewRemessas($c);      break;
      case 'inventario':    await viewInventario($c);    break;
      case 'divergencias':  await viewDivergencias($c);  break;
      case 'mobile':        await viewMobile($c);        break;
      case 'reposicao':     await viewReposicao($c);     break;
      case 'sync-esl':      await viewSyncEsl($c);       break;
      case 'automacoes':    await viewAutomacoes($c);    break;
      case 'saude':         await viewSaude($c);         break;
      default: navigate('dashboard');
    }
  } catch (err) {
    console.error(err);
    $c.innerHTML = `<div class="card"><div class="empty">⚠ Erro ao carregar: ${escapeHTML(err.message)}</div></div>`;
  }
}

// ─── VIEW · Dashboard ─────────────────────────────────────────────────
async function viewDashboard($c) {
  const [stats, topClis, abc, health] = await Promise.all([repo.stats(), repo.topClientes(8), repo.abcXyz(), repo.health()]);
  const inboundCtes = (await db.from('cte_frete').select('id,valor_nf', { count: 'exact' }).eq('direcao_frete', 'inbound_para_binario_joi'));
  const outboundCtes = (await db.from('cte_frete').select('id,valor_nf', { count: 'exact' }).eq('direcao_frete', 'outbound_de_binario_joi'));
  const inboundCtesVlr = (inboundCtes.data || []).reduce((a, r) => a + Number(r.valor_nf || 0), 0);
  const outboundCtesVlr = (outboundCtes.data || []).reduce((a, r) => a + Number(r.valor_nf || 0), 0);
  const allOk = health.every(h => h.status_freshness === 'OK');
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">VISÃO EXECUTIVA</div>
        <h1>Operação Binário · <strong>tempo real</strong></h1>
        <p class="lead">A operação 3PL da Ícaro Express no galpão de Joinville, refletida em tempo real. Inteligência em órbita.</p>
      </div>
      <div class="page-head-actions">
        <span class="pill ${allOk ? 'pill-green' : 'pill-amber'}">${allOk ? '● Saúde OK' : '● Verificar saúde'}</span>
      </div>
    </header>

    <div class="stats">
      <div class="stat"><div class="label">SKUs catalogados</div><div class="value">${NUM(stats.skus)}</div><div class="delta">${stats.movimentos} movimentos · ${stats.nfes} NF-e</div></div>
      <div class="stat success"><div class="label">Valor em estoque</div><div class="value">${BRL(stats.valor_estoque_atual)}</div><div class="delta">Saldo positivo · vlr × ref</div></div>
      <div class="stat"><div class="label">CTes inbound</div><div class="value">${NUM(inboundCtes.count || 0)}</div><div class="delta">${BRL(inboundCtesVlr)} recebidos</div></div>
      <div class="stat"><div class="label">CTes outbound</div><div class="value">${NUM(outboundCtes.count || 0)}</div><div class="delta">${BRL(outboundCtesVlr)} expedidos</div></div>
      <div class="stat ${stats.divergencias_abertas > 0 ? 'warning' : 'success'}"><div class="label">Divergências em aberto</div><div class="value">${NUM(stats.divergencias_abertas)}</div><div class="delta">${stats.divergencias_abertas === 0 ? 'Nenhuma pendente' : 'Ciclo PDCA ativo'}</div></div>
    </div>

    <div class="grid-2">
      <div class="card">
        <div class="card-head"><h2>Top destinos <span class="count">jan – mai 2026</span></h2></div>
        <table class="tbl">
          <thead><tr><th>Cliente</th><th class="num">CTes</th><th class="num">Valor NF</th></tr></thead>
          <tbody>
            ${topClis.length === 0 ? '<tr><td colspan="3" class="empty">Sem dados</td></tr>' : topClis.map(c => `
              <tr><td class="strong">${escapeHTML(SHORT(c.cliente, 38))}</td><td class="num">${NUM(c.ctes)}</td><td class="num">${BRL(c.valor_total)}</td></tr>
            `).join('')}
          </tbody>
        </table>
      </div>
      <div class="card">
        <div class="card-head"><h2>Matriz ABC × XYZ</h2></div>
        ${renderMatrixHtml(abc)}
        <div class="card-foot">
          <span>SKUs distribuídos em 9 quadrantes de slotting</span>
          <a href="#/abc">Detalhes →</a>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-head"><h2>Saúde dos dados <span class="count">freshness gate</span></h2></div>
      ${renderHealthHtml(health)}
    </div>
  `;
}

function renderMatrixHtml(abcData) {
  const map = {};
  for (const r of abcData) map[`${r.abc}-${r.xyz}`] = r;
  const rows = ['A', 'B', 'C'];
  const cols = ['X', 'Y', 'Z'];
  let html = '<div class="matrix">';
  html += '<div class="matrix-cell header"><span class="label">ABC \\ XYZ</span></div>';
  for (const c of cols) html += `<div class="matrix-cell header"><span class="label">${c}</span></div>`;
  for (const r of rows) {
    html += `<div class="matrix-cell row-label"><span class="label">${r}</span></div>`;
    for (const c of cols) {
      const cell = map[`${r}-${c}`];
      const n = cell?.skus || 0;
      html += `<div class="matrix-cell q"><div class="qcount ${n === 0 ? 'zero' : ''}">${n}</div><div class="qvalue">${cell ? BRL(cell.valor_movimentado) : ''}</div></div>`;
    }
  }
  html += '</div>';
  return html;
}

function renderHealthHtml(rows) {
  if (!rows || !rows.length) return '<div class="empty">Sem fontes registradas</div>';
  return rows.map(r => {
    const status = r.status_freshness;
    const cls = status === 'OK' ? '' : status === 'ATENCAO' ? 'atencao' : 'critico';
    const pillCls = status === 'OK' ? 'pill-green' : status === 'ATENCAO' ? 'pill-amber' : 'pill-red';
    const pct = status === 'OK' ? 100 : status === 'ATENCAO' ? 50 : 15;
    const horas = Number(r.horas_desde_ultima_ingestao || 0).toFixed(1);
    return `
      <div class="health-row ${cls}">
        <div class="name">${escapeHTML(r.source_name)}</div>
        <div class="bar"><div class="bar-fill" style="width: ${pct}%"></div></div>
        <div class="meta">${horas}h atrás</div>
        <div><span class="pill ${pillCls}">${status}</span></div>
      </div>`;
  }).join('');
}

// ─── VIEW · Estoque ────────────────────────────────────────────────────
async function viewEstoque($c) {
  const skus = await repo.estoque();
  const valorTotal = skus.reduce((a, s) => a + (Number(s.valor_estoque) || 0), 0);
  const positivos = skus.filter(s => Number(s.saldo_qtd) > 0).length;
  const negativos = skus.filter(s => Number(s.saldo_qtd) < 0).length;
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">POSIÇÃO TEMPO REAL</div>
        <h1>Estoque <strong>agora</strong></h1>
        <p class="lead">Saldo SKU = soma de entradas menos saídas. Valor de estoque = saldo × valor de referência.</p>
      </div>
    </header>
    <div class="stats">
      <div class="stat"><div class="label">SKUs com saldo +</div><div class="value">${NUM(positivos)}</div></div>
      <div class="stat ${negativos > 0 ? 'warning' : ''}"><div class="label">SKUs com saldo −</div><div class="value">${NUM(negativos)}</div></div>
      <div class="stat success"><div class="label">Valor total</div><div class="value">${BRL(valorTotal)}</div></div>
      <div class="stat"><div class="label">SKUs listados</div><div class="value">${NUM(skus.length)}</div></div>
    </div>
    <div class="card">
      <div class="card-head"><h2>Posição por SKU <span class="count">${skus.length}</span></h2></div>
      <table class="tbl">
        <thead><tr>
          <th>Código</th><th>Descrição</th><th>Categ.</th><th>Classe</th><th>Endereço</th>
          <th class="num">Saldo</th><th class="num">Vlr unit.</th><th class="num">Vlr estoque</th>
        </tr></thead>
        <tbody>
          ${skus.length === 0 ? '<tr><td colspan="8" class="empty">Sem dados</td></tr>' : skus.map(s => `
            <tr>
              <td class="mono">${escapeHTML(SHORT(s.sku_codigo, 24))}</td>
              <td>${escapeHTML(SHORT(s.descricao, 60))}</td>
              <td class="text-mute">${escapeHTML(s.categoria || '—')}</td>
              <td><span class="pill ${classPill(s.classe_abc)}">${s.classe_abc || '·'} ${s.classe_xyz || ''}</span></td>
              <td class="mono">${escapeHTML(s.endereco_atual || '—')}</td>
              <td class="num">${QTY(s.saldo_qtd)}</td>
              <td class="num">${BRL(s.valor_referencia)}</td>
              <td class="num strong">${BRL(s.valor_estoque)}</td>
            </tr>`).join('')}
        </tbody>
      </table>
    </div>
  `;
}

function classPill(abc) { return abc === 'A' ? 'pill-solid-blue' : abc === 'B' ? 'pill-blue' : 'pill-mute'; }

// ─── VIEW · Movimentação ───────────────────────────────────────────────
async function viewMovimento($c) {
  const inbound = await repo.movimentos({ fluxo: 'inbound', limit: 50 });
  const outbound = await repo.movimentos({ fluxo: 'outbound', limit: 50 });
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">LINHA DO TEMPO</div>
        <h1>Movimentação · <strong>entradas e saídas</strong></h1>
        <p class="lead">Cada item de NF-e gera uma linha. Ordenado pelos mais recentes.</p>
      </div>
    </header>
    <div class="grid-2">
      <div class="card">
        <div class="card-head"><h2>Entradas <span class="count">${inbound.length}</span></h2></div>
        ${renderMovTable(inbound, 'inbound')}
      </div>
      <div class="card">
        <div class="card-head"><h2>Saídas <span class="count">${outbound.length}</span></h2></div>
        ${renderMovTable(outbound, 'outbound')}
      </div>
    </div>
  `;
}

function renderMovTable(rows, fluxo) {
  if (!rows.length) return '<div class="empty">Sem registros</div>';
  return `
    <table class="tbl">
      <thead><tr><th>Data</th><th>SKU</th><th>Descrição</th><th>CFOP</th><th class="num">Qtd</th><th class="num">Vlr</th></tr></thead>
      <tbody>
        ${rows.map(m => `
          <tr>
            <td class="mono">${DATE(m.data_emissao)}</td>
            <td class="mono">${escapeHTML(SHORT(m.sku_codigo, 18))}</td>
            <td>${escapeHTML(SHORT(m.descricao, 38))}</td>
            <td class="mono text-mute">${escapeHTML(m.cfop || '')}</td>
            <td class="num">${QTY(m.qtd)}</td>
            <td class="num">${BRL(m.vlr_total)}</td>
          </tr>`).join('')}
      </tbody>
    </table>
  `;
}

// ─── VIEW · ABC × XYZ ─────────────────────────────────────────────────
async function viewAbcXyz($c) {
  const abc = await repo.abcXyz();
  const total = abc.reduce((a, r) => a + (Number(r.skus) || 0), 0);
  const valor = abc.reduce((a, r) => a + (Number(r.valor_movimentado) || 0), 0);
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">SLOTTING DINÂMICO</div>
        <h1>Matriz <strong>ABC × XYZ</strong></h1>
        <p class="lead">ABC por valor movimentado (Pareto) · XYZ por variabilidade da demanda (coeficiente de variação). Nove quadrantes, nove políticas.</p>
      </div>
    </header>
    <div class="stats">
      <div class="stat"><div class="label">Total de SKUs ativos</div><div class="value">${NUM(total)}</div></div>
      <div class="stat success"><div class="label">Valor movimentado</div><div class="value">${BRLmi(valor)}</div></div>
      <div class="stat"><div class="label">Classes preenchidas</div><div class="value">${abc.length}/9</div></div>
    </div>
    <div class="card">
      <div class="card-head"><h2>Distribuição por quadrante</h2></div>
      ${renderMatrixHtml(abc)}
    </div>
    <div class="card">
      <div class="card-head"><h2>Política de slotting</h2></div>
      <table class="tbl">
        <thead><tr><th>Classe</th><th>Definição</th><th>Rua</th><th>Nível</th><th>Política</th></tr></thead>
        <tbody>
          <tr><td><span class="pill pill-solid-blue">AX</span></td><td>Alto valor · estável</td><td class="mono">A</td><td class="mono">1</td><td>Golden zone · min/max apertado · forecast estatístico</td></tr>
          <tr><td><span class="pill pill-solid-blue">AY</span></td><td>Alto valor · variável</td><td class="mono">A</td><td class="mono">1</td><td>Golden zone + reserva sazonal · revisão mensal</td></tr>
          <tr><td><span class="pill pill-solid-blue">AZ</span></td><td>Alto valor · errático</td><td class="mono">B</td><td class="mono">1</td><td>Espaço de segurança extra · reposição sob demanda</td></tr>
          <tr><td><span class="pill pill-blue">BX</span></td><td>Valor médio · estável</td><td class="mono">C</td><td class="mono">1</td><td>Min/max moderado · revisão trimestral</td></tr>
          <tr><td><span class="pill pill-blue">BY</span></td><td>Valor médio · variável</td><td class="mono">C</td><td class="mono">2</td><td>Min/max sazonal</td></tr>
          <tr><td><span class="pill pill-blue">BZ</span></td><td>Valor médio · errático</td><td class="mono">D</td><td class="mono">2</td><td>Reposição reativa</td></tr>
          <tr><td><span class="pill pill-mute">CX</span></td><td>Baixo valor · estável</td><td class="mono">E</td><td class="mono">2</td><td>Min/max conservador</td></tr>
          <tr><td><span class="pill pill-mute">CY</span></td><td>Baixo valor · variável</td><td class="mono">E</td><td class="mono">3</td><td>Revisão semestral</td></tr>
          <tr><td><span class="pill pill-mute">CZ</span></td><td>Baixo valor · errático</td><td class="mono">F+</td><td class="mono">3</td><td>Cross-dock se possível · topo do galpão</td></tr>
        </tbody>
      </table>
    </div>
  `;
}

// ─── VIEW · Fretes ─────────────────────────────────────────────────────
async function viewFretes($c) {
  const fretes = await repo.fretes({ limit: 200 });
  const inb = fretes.filter(f => f.direcao_frete === 'inbound_para_binario_joi');
  const out = fretes.filter(f => f.direcao_frete === 'outbound_de_binario_joi');
  const inbVlr = inb.reduce((a, f) => a + Number(f.valor_nf || 0), 0);
  const outVlr = out.reduce((a, f) => a + Number(f.valor_nf || 0), 0);
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">CTes ÍCARO VINCULADOS</div>
        <h1>Fretes <strong>ESL Cloud</strong></h1>
        <p class="lead">82 CTes Ícaro identificados no período. Match automático com movimentos via número da NF.</p>
      </div>
    </header>
    <div class="stats">
      <div class="stat"><div class="label">Inbound JOI</div><div class="value">${NUM(inb.length)}</div><div class="delta">${BRL(inbVlr)} recebidos</div></div>
      <div class="stat"><div class="label">Outbound clientes</div><div class="value">${NUM(out.length)}</div><div class="delta">${BRL(outVlr)} expedidos</div></div>
      <div class="stat success"><div class="label">Vinculados</div><div class="value">${NUM(fretes.filter(f => f.match_status === 'vinculado_a_movimento').length)}</div></div>
      <div class="stat warning"><div class="label">Aguardando NF</div><div class="value">${NUM(fretes.filter(f => f.match_status !== 'vinculado_a_movimento').length)}</div></div>
    </div>
    <div class="card">
      <div class="card-head"><h2>CTes do período <span class="count">${fretes.length}</span></h2></div>
      <table class="tbl">
        <thead><tr>
          <th>Data</th><th>CTe</th><th>NF</th><th>Destinatário</th><th>Cidade</th>
          <th class="num">Valor NF</th><th>Direção</th><th>Match</th>
        </tr></thead>
        <tbody>
          ${fretes.map(f => `
            <tr>
              <td class="mono">${DATE(f.data_frete)}</td>
              <td class="mono">${escapeHTML(f.cte_numero || '')}</td>
              <td class="mono">${escapeHTML(f.nf_numero || '—')}</td>
              <td>${escapeHTML(SHORT(f.destinatario || '(sem destinatário)', 38))}</td>
              <td class="text-mute">${escapeHTML(f.cidade_destino || '')}</td>
              <td class="num strong">${BRL(f.valor_nf)}</td>
              <td><span class="pill ${f.direcao_frete === 'inbound_para_binario_joi' ? 'pill-green' : 'pill-amber'}">${f.direcao_frete === 'inbound_para_binario_joi' ? 'IN' : 'OUT'}</span></td>
              <td><span class="pill ${f.match_status === 'vinculado_a_movimento' ? 'pill-green' : f.match_status === 'nf_nao_carregada_ainda' ? 'pill-amber' : 'pill-mute'}">${f.match_status === 'vinculado_a_movimento' ? '●' : f.match_status === 'nf_nao_carregada_ainda' ? 'aguarda XML' : 'sem NF'}</span></td>
            </tr>`).join('')}
        </tbody>
      </table>
    </div>
  `;
}

// ─── VIEW · Saúde dos dados ───────────────────────────────────────────
async function viewSaude($c) {
  const [health, stats] = await Promise.all([repo.health(), repo.stats()]);
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">FRESHNESS GATE</div>
        <h1>Saúde <strong>dos dados</strong></h1>
        <p class="lead">Status de ingestão por fonte. Threshold OK / ATENÇÃO / CRÍTICO baseado em horas desde a última carga.</p>
      </div>
    </header>
    <div class="card">
      <div class="card-head"><h2>Fontes de dados</h2></div>
      ${renderHealthHtml(health)}
      <div class="card-foot">
        <span>Ingestão via edge function <span class="text-mono">binario-wms-ingest</span> ou pipeline Python local</span>
        <span class="text-mono">${stats.nfes} NF-e · ${stats.skus} SKUs · ${stats.ctes} CTes</span>
      </div>
    </div>
    <div class="grid-2">
      <div class="card">
        <div class="card-head"><h2>Como enviar novos XMLs</h2></div>
        <p class="text-sm" style="margin-bottom:14px;">A ingestão é idempotente. Reenviar o mesmo XML não duplica.</p>
        <pre style="background:var(--navy);color:#A7B5DC;padding:16px;border-radius:8px;font-size:11.5px;line-height:1.55;overflow-x:auto;font-family:var(--mono);">curl -X POST https://hbrvoairynwsliyxxgsg.supabase.co/functions/v1/binario-wms-ingest \\
  -H "Authorization: Bearer SUPABASE_KEY" \\
  -H "Content-Type: application/xml" \\
  -H "X-Ingest-Source: xml_nfeProc" \\
  --data-binary @nota.xml</pre>
      </div>
      <div class="card">
        <div class="card-head"><h2>Próxima onda</h2></div>
        <ul style="list-style:none; padding:0;">
          <li style="padding:8px 0; border-bottom:1px solid var(--line); font-size:13px;"><span class="pill pill-solid-blue" style="margin-right:8px;">ONDA 1</span> Watcher Mac mini · cron diário 06h</li>
          <li style="padding:8px 0; border-bottom:1px solid var(--line); font-size:13px;"><span class="pill pill-blue" style="margin-right:8px;">ONDA 2</span> Etiquetas QR + PWA mobile</li>
          <li style="padding:8px 0; font-size:13px;"><span class="pill pill-mute" style="margin-right:8px;">ONDA 2+</span> Sensores de pesagem doca</li>
        </ul>
      </div>
    </div>
  `;
}

// ─── Boot ──────────────────────────────────────────────────────────────
async function boot() {
  try {
    const user = await getCurrentUser();
    if (!user) return renderLogin();
    if (!isAuthorizedEmail(user.email)) {
      await auth.auth.signOut();
      return renderLogin({ kind: 'err', text: 'E-mail não autorizado. Acesso restrito @icaroexpress.com e @binario.*' });
    }
    await renderApp(user);
  } catch (e) {
    console.error(e);
    renderLogin({ kind: 'err', text: e.message || 'Falha ao inicializar a torre.' });
  }
}

auth.auth.onAuthStateChange((evt, session) => {
  if (evt === 'SIGNED_IN' && session?.user) {
    if (isAuthorizedEmail(session.user.email)) renderApp(session.user);
    else { auth.auth.signOut(); renderLogin({ kind: 'err', text: 'E-mail não autorizado.' }); }
  } else if (evt === 'SIGNED_OUT') {
    renderLogin();
  }
});

// Registra Service Worker para suporte PWA offline + cache
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => console.warn('SW falhou:', e));
  });
}

boot();
